import verificationIcon from "../../constants/images/modal-verification.svg";
import styles from "./ModalVerification.module.scss";

const ModalVerification = () => {

  return (
    <div className={styles.modal}>
      <div className={styles.modal_content}>
        <img src={verificationIcon} alt="verification icon"/>
        <h2>ТРИВАЄ ВЕРИФІКАЦІЯ КЛІНЕРА</h2>
        <p>Дякуєм за реєстрацію клінера на KovaApp! Протягом 3 днів з Вами звʼяжеться наш спеціаліст для проведення верифікації ваших данних. Після успішної верифікації у Вас буде доступ до 1000 нових замовлень кожного дня. 
          Якщо наш спеціаліст не зможе звʼязатись з Вами впродовж 3 днів, зателефонуйте будь ласка за номером телефону
          <a href="tel:+380934543543"> +380934543543 </a>
        </p>
      </div>
    </div>
  );
};

export default ModalVerification;
